module.exports = __webpack_public_path__ + "img/1.3cc878d1.png";